import React, { useEffect, useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import localforage from 'localforage'
import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { AccountWrapper, Field, SecureField, Awaiter } from './components'
import * as requests from '#src/requests'
import { useRecoilState } from 'recoil'
import {
  resetCodeState,
  tokenState,
} from '#state'

export default function UpdatePassword (props) {
  const { root, to } = props
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [token, setToken] = useRecoilState(tokenState)
  const [code, setCode] = useRecoilState(resetCodeState)

  const [pass, setPass] = useState('')
  const [loginError, setLoginError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [showErrors, setShowErrors] = useState(false)
  const [isAwaiting, setIsAwaiting] = useState(false)

  useEffect(() => {
    if (code === '') {
      const errMessage = t('account.errors.emptyCode')
      setLoginError(errMessage)
    } else {
      setLoginError('')
    }
    // check password
    if (pass === '') {
      const errMessage = t('account.errors.emptyPass')
      setPasswordError(errMessage)
    } else {
      setPasswordError('')
    }
  }, [code, pass])

  const check = async event => {
    // app root reload \ rerender fix
    event.preventDefault()
    if (loginError || passwordError) {
      console.log('code or pass incorrect')
      setShowErrors(true)
    } else {
      setIsAwaiting(true)
      const result = await requests.updatePass(code, pass)
      setIsAwaiting(false)
      if (!result.success) {
        console.log('updatePass error', result)
        if (result.error) {
          setShowErrors(true)
          const errMessage = t(`account.errors.${result.error}`)
          console.log('errMessage', errMessage)
          setPasswordError(errMessage)
        } else {
          setPasswordError('')
        }
      } else {
        setShowErrors(false)
        console.log('updatePass success', result)
        setToken(result.token)
        try {
          await localforage.setItem('token', result.token)
        } catch (err) {
          console.log('save token error', err)
        }
        navigate('/')
        // trackEvent('Login')
        // navigate('/', { replace: true })
      }
    }
  }

  return (
    <>
      <AccountWrapper root={root} to={to}>
        <Grid
          component='form'
          container
          direction='column'
          alignItems='center'
          justifyContent='space-evenly'
          sx={{
            px: 5,
            py: 5,
            borderRadius: 2,
            // border: '1px solid',
            // borderColor: 'action.selected'
          }}
          onSubmit={check}
        >
          <Grid
            item
            container
            direction='column'
            alignItems='center'
            justifyContent='space-between'
            sx={{
              minHeight: '15vh'
            }}
          >
            <Typography textAlign='center' variant='h4'>{t('account.updatePass.title')}</Typography>

            <Grid item container alignItems='center' justifyContent='center'>
              <Typography>{t('account.updatePass.createPre')}</Typography>
              <Button
                sx={{ textTransform: 'none', cursor: 'pointer' }}
                onClick={() => {
                  navigate('/account/register', { replace: true })
                }}
              >
                <Typography>{t('account.updatePass.createLink')}</Typography>
              </Button>
            </Grid>
          </Grid>

          <Grid
            item
            container
            direction='column'
            alignItems='stretch'
            justifyContent='space-evenly'
            sx={{
              minHeight: '26vh'
            }}
          >
            <Field
              value={code}
              setValue={setCode}
              label={t('account.updatePass.codeLabel')}
              placeholder={t('account.updatePass.codePlaceholder')}
              errorMessage={loginError}
              showErrors={showErrors}
            />
            <SecureField
              value={pass}
              setValue={setPass}
              label={t('account.updatePass.passLabel')}
              placeholder={t('account.updatePass.passPlaceholder')}
              type='password'
              autoComplete='current-password'
              errorMessage={passwordError}
              showErrors={showErrors}
              secureTextEntry
            />
          </Grid>
          <Grid
            item
            container
            direction='column'
            alignItems='center'
            justifyContent='space-between'
            sx={{
              minHeight: '25vh'
            }}
          >
            <Button
              fullWidth
              variant='contained'
              size='large'
              type="submit"
            >
              <Typography>{t('account.updatePass.mainBtn')}</Typography>
            </Button>
            <Button
              sx={{ textTransform: 'none', cursor: 'pointer' }}
              onClick={() => {
                console.log('forgot password')
                navigate('/account/resetpass', { replace: true })
              }}
            >
              <Typography>{t('account.updatePass.resetLink')}</Typography>
            </Button>
            <Button
              fullWidth
              variant='outlined'
              size='large'
              onClick={() => {
                navigate('/account/otclogin', { replace: true })
              }}
            >
              <Typography>{t('account.updatePass.otcBtn')}</Typography>
            </Button>
          </Grid>
        </Grid>
      </AccountWrapper>
      <Awaiter isAwaiting={isAwaiting} />
    </>
  )
}
